(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lcw-shoppable-video"] && !Shopify.designMode) return;
  try {
    
  class LcwShoppableVideo extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.lcw-svideo__track');
      this.prevBtn = this.querySelector('[data-direction="prev"]');
      this.nextBtn = this.querySelector('[data-direction="next"]');
      this.trackingOn = this.dataset.tracking === 'true';
      this.autoplayOn = this.dataset.autoplay === 'true';
      this.listId = this.dataset.listId || 'lcw_shoppable_video';

      this.bindArrows();
      this.bindSlides();
      this.setupCarouselAutoplay();
      this.setupImpressions();
      this.updateArrows();
      this.track && this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateArrows(), { passive: true });
    }

    bindArrows() {
      [this.prevBtn, this.nextBtn].forEach((btn) => {
        if (!btn) return;
        btn.addEventListener('click', () => {
          const dir = btn.dataset.direction === 'next' ? 1 : -1;
          this.track.scrollBy({ left: dir * this.track.clientWidth * 0.9, behavior: 'smooth' });
        });
      });
    }

    updateArrows() {
      if (!this.track || !this.prevBtn || !this.nextBtn) return;
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      this.prevBtn.toggleAttribute('disabled', scrollLeft <= 1);
      this.nextBtn.toggleAttribute('disabled', scrollLeft >= scrollWidth - clientWidth - 1);
    }

    setupCarouselAutoplay() {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!this.autoplayOn || reduce) return;
      const vids = this.querySelectorAll('.lcw-svideo__cvideo');
      if (!vids.length || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          const v = e.target;
          if (e.isIntersecting) { v.muted = true; v.play().catch(() => {}); } else { v.pause(); }
        });
      }, { threshold: 0.5 });
      vids.forEach((v) => io.observe(v));
    }

    bindSlides() {
      const slides = Array.from(this.querySelectorAll('.lcw-svideo__slide'));
      slides.forEach((slide, idx) => {
        const trigger = slide.querySelector('.lcw-svideo__trigger');
        const dialog = slide.querySelector('.lcw-svideo__modal');
        if (!trigger || !dialog) return;
        const video = dialog.querySelector('.lcw-svideo__modal-video video');
        const aside = dialog.querySelector('.lcw-svideo__modal-aside');

        trigger.addEventListener('click', () => this.openModal(dialog, video, slide));
        dialog.querySelector('.lcw-svideo__close')?.addEventListener('click', () => this.closeModal(dialog, video));
        dialog.addEventListener('click', (e) => { if (e.target === dialog) this.closeModal(dialog, video); });
        dialog.addEventListener('close', () => { if (video) video.pause(); });

        // navegação entre vídeos
        const prevNav = dialog.querySelector('[data-modal-nav="prev"]');
        const nextNav = dialog.querySelector('[data-modal-nav="next"]');
        if (slides.length <= 1) {
          prevNav && (prevNav.hidden = true);
          nextNav && (nextNav.hidden = true);
        } else {
          prevNav?.addEventListener('click', () => this.gotoSlide(slides, idx, -1));
          nextNav?.addEventListener('click', () => this.gotoSlide(slides, idx, 1));

          // swipe horizontal na área do vídeo (touch)
          const videoWrap = dialog.querySelector('.lcw-svideo__modal-video');
          if (videoWrap) {
            let startX = 0, startY = 0, tracking = false;
            videoWrap.addEventListener('touchstart', (e) => {
              const t = e.changedTouches[0];
              startX = t.clientX; startY = t.clientY; tracking = true;
            }, { passive: true });
            videoWrap.addEventListener('touchend', (e) => {
              if (!tracking) return;
              tracking = false;
              const t = e.changedTouches[0];
              const dx = t.clientX - startX;
              const dy = t.clientY - startY;
              if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
                this.gotoSlide(slides, idx, dx < 0 ? 1 : -1);
              }
            }, { passive: true });
          }
        }

        dialog.querySelector('[data-action="playpause"]')?.addEventListener('click', () => {
          if (!video) return;
          video.paused ? video.play() : video.pause();
        });
        dialog.querySelector('[data-action="mute"]')?.addEventListener('click', () => {
          if (!video) return;
          video.muted = !video.muted;
          dialog.classList.toggle('is-muted', video.muted);
        });
        if (video) {
          video.addEventListener('play', () => dialog.classList.add('is-playing'));
          video.addEventListener('pause', () => dialog.classList.remove('is-playing'));
          this.bindTimeline(dialog, video);
        }

        dialog.querySelectorAll('[data-buy]').forEach((btn) => {
          btn.addEventListener('click', () => { this.openDetail(aside, btn.dataset.buy); this.trackSelect(dialog, btn.dataset.buy); });
        });
        dialog.querySelectorAll('.lcw-svideo__back').forEach((b) => b.addEventListener('click', () => this.closeDetail(aside)));
        dialog.querySelectorAll('.lcw-svideo__atc-form form').forEach((form) => {
          form.addEventListener('submit', () => {
            const d = form.closest('.lcw-svideo__detail');
            if (d) this.trackAddToCart(dialog, d.dataset.detailId);
          });
        });
      });
    }

    bindTimeline(dialog, video) {
      const timeline = dialog.querySelector('.lcw-svideo__timeline');
      const fill = dialog.querySelector('.lcw-svideo__timeline-fill');
      if (!timeline || !fill) return;
      video.addEventListener('timeupdate', () => {
        fill.style.width = (video.duration ? (video.currentTime / video.duration) * 100 : 0) + '%';
      });
      const seek = (clientX) => {
        const rect = timeline.getBoundingClientRect();
        const ratio = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
        if (video.duration) video.currentTime = ratio * video.duration;
      };
      timeline.addEventListener('click', (e) => seek(e.clientX));
    }

    openModal(dialog, video, slide) {
      dialog.showModal();
      if (video) {
        video.muted = false;
        dialog.classList.remove('is-muted');
        video.play().then(() => dialog.classList.add('is-playing')).catch(() => {
          video.muted = true; dialog.classList.add('is-muted'); video.play().catch(() => {});
        });
      }
      this.trackViewList(slide);
    }

    closeModal(dialog, video) {
      if (video) video.pause();
      this.closeDetail(dialog.querySelector('.lcw-svideo__modal-aside'));
      dialog.close();
    }

    gotoSlide(slides, idx, dir) {
      const cur = slides[idx];
      const curDialog = cur.querySelector('.lcw-svideo__modal');
      const curVideo = curDialog.querySelector('.lcw-svideo__modal-video video');
      const n = (idx + dir + slides.length) % slides.length;
      const nx = slides[n];
      const nxDialog = nx.querySelector('.lcw-svideo__modal');
      const nxVideo = nxDialog.querySelector('.lcw-svideo__modal-video video');
      this.closeModal(curDialog, curVideo);
      requestAnimationFrame(() => this.openModal(nxDialog, nxVideo, nx));
    }

    openDetail(aside, productId) {
      aside.querySelectorAll('.lcw-svideo__detail').forEach((d) => {
        d.classList.toggle('lcw-svideo__detail--active', d.dataset.detailId === productId);
      });
      aside.classList.add('is-detail');
    }
    closeDetail(aside) {
      if (!aside) return;
      aside.classList.remove('is-detail');
      aside.querySelectorAll('.lcw-svideo__detail--active').forEach((d) => d.classList.remove('lcw-svideo__detail--active'));
    }

    publish(name, data) {
      if (!this.trackingOn) return;
      try {
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
          Shopify.analytics.publish(name, data);
        }
      } catch (e) {}
    }
    itemsFrom(slide) {
      return Array.from(slide.querySelectorAll('[data-product-id]')).map((el, i) => ({
        product_id: el.dataset.productId, product_title: el.dataset.productTitle,
        price: parseFloat(el.dataset.productPrice) || undefined, index: i,
      }));
    }
    productData(dialog, productId) {
      const el = dialog.querySelector('[data-product-id="' + productId + '"]');
      if (!el) return {};
      return { product_id: el.dataset.productId, product_title: el.dataset.productTitle, price: parseFloat(el.dataset.productPrice) || undefined };
    }
    setupImpressions() {
      if (!this.trackingOn || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting && !e.target.dataset.lcwViewed) {
            e.target.dataset.lcwViewed = '1';
            this.publish('lcw_video_view', { list_id: this.listId, list_name: 'LCW Shoppable Video', items: this.itemsFrom(e.target) });
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.5 });
      this.querySelectorAll('.lcw-svideo__slide').forEach((s) => io.observe(s));
    }
    trackViewList(slide) { this.publish('lcw_video_open', { list_id: this.listId, list_name: 'LCW Shoppable Video', items: this.itemsFrom(slide) }); }
    trackSelect(dialog, productId) { this.publish('lcw_video_select', Object.assign({ list_id: this.listId }, this.productData(dialog, productId))); }
    trackAddToCart(dialog, productId) { this.publish('lcw_video_atc', Object.assign({ list_id: this.listId }, this.productData(dialog, productId))); }
  }
  if (!customElements.get('lcw-shoppable-video')) customElements.define('lcw-shoppable-video', LcwShoppableVideo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lcw-slideshow-plus"] && !Shopify.designMode) return;
  try {
    
  /* LCW Slideshow Plus 1.9.2 — comportamento (altura limite por breakpoint) */
  class LcwHeroPlusSlideshow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-lcw-track-plus]');
      this.viewport = this.querySelector('.lcw-hero-plus__viewport');
      this.slides = Array.from(this.querySelectorAll('[data-lcw-slide-plus]'));
      if (!this.track || this.slides.length === 0) return;

      this.index = 0;
      this.layout = this.dataset.layout || 'full_frame';
      this.isHints = this.layout === 'with_hints';
      this.pagStyle = this.dataset.pagStyle || 'dots';

      this.prevBtn = this.querySelector('.lcw-hero-plus__arrow--prev');
      this.nextBtn = this.querySelector('.lcw-hero-plus__arrow--next');
      this.paginationEl = this.querySelector('.lcw-hero-plus__pagination');
      this.pagItems = Array.from(this.querySelectorAll('[data-lcw-pag-item-plus]'));

      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.timer = null;
      this.paused = false;
      this.dragging = false;
      this.moved = false;
      this.startX = 0;
      this.curX = 0;
      this.threshold = 40;
      this.resizeRaf = null;
      this.baseOffset = 0;
      this.progressAnim = null;
      this.ac = new AbortController();
      this.single = this.slides.length <= 1;

      this.gaEnabled = this.dataset.ga === 'true';
      this.gaMethod = this.dataset.gaMethod || 'pixel';
      this.gaLocation = this.dataset.gaLocation || 'home_hero';
      this.viewed = new Set();
      this.inView = false;

      this.maxHeightD = parseInt(this.dataset.maxHeightD || 0, 10);
      this.maxHeightM = parseInt(this.dataset.maxHeightM || 0, 10);
      this.mqMobile = window.matchMedia('(max-width: 749px)');

      if (!this.autoplay) this.classList.add('lcw-hero-plus--no-autoplay');

      if (!this.single) {
        if (this.prevBtn) this.prevBtn.hidden = false;
        if (this.nextBtn) this.nextBtn.hidden = false;
        if (this.paginationEl) this.paginationEl.hidden = false;
        this.bindControls();
        this.bindDrag();
        this.bindKeys();
        this.bindAutoplayGuards();
      }
      this.bindEditorEvents();
      this.bindHeightWatchers();
      this.bindTracking();

      this.goTo(0, false);
      if (this.autoplay && !this.single && !this.reduceMotion) this.start();
    }

    bindControls() {
      const sig = { signal: this.ac.signal };
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => { this.prev(); this.restart(); }, sig);
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => { this.next(); this.restart(); }, sig);
      this.pagItems.forEach((it) => {
        it.addEventListener('click', () => { this.goTo(parseInt(it.dataset.lcwPagItemPlus, 10)); this.restart(); }, sig);
      });
    }

    bindKeys() {
      if (!this.hasAttribute('tabindex')) this.tabIndex = 0;
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { this.prev(); this.restart(); }
        else if (e.key === 'ArrowRight') { this.next(); this.restart(); }
      }, { signal: this.ac.signal });
    }

    bindDrag() {
      const vp = this.viewport;
      const sig = { signal: this.ac.signal };
      vp.addEventListener('touchstart', (e) => this.dragStart(e.touches[0].clientX), { passive: true, signal: this.ac.signal });
      vp.addEventListener('touchmove', (e) => this.dragMove(e.touches[0].clientX), { passive: true, signal: this.ac.signal });
      vp.addEventListener('touchend', () => this.dragEnd(), sig);
      vp.addEventListener('mousedown', (e) => {
        if (e.target.closest('button, a, input, select, textarea')) return;
        this.dragStart(e.clientX); e.preventDefault();
      }, sig);
      window.addEventListener('mousemove', (e) => { if (this.dragging) this.dragMove(e.clientX); }, sig);
      window.addEventListener('mouseup', () => { if (this.dragging) this.dragEnd(); }, sig);
      vp.addEventListener('click', (e) => {
        if (this.moved) { e.preventDefault(); e.stopPropagation(); this.moved = false; }
      }, { capture: true, signal: this.ac.signal });
    }

    dragStart(x) {
      this.dragging = true; this.moved = false;
      this.startX = x; this.curX = x;
      this.track.style.transition = 'none';
      this.stop();
    }
    dragMove(x) {
      if (!this.dragging) return;
      this.curX = x;
      const diff = x - this.startX;
      if (Math.abs(diff) > 5) this.moved = true;
      if (this.isHints) {
        this.track.style.transform = `translateX(${-this.baseOffset + diff}px)`;
      } else {
        this.track.style.transform = `translateX(calc(${-this.index * 100}% + ${diff}px))`;
      }
    }
    dragEnd() {
      if (!this.dragging) return;
      this.dragging = false;
      this.track.style.transition = '';
      const diff = this.curX - this.startX;
      if (diff < -this.threshold) this.next();
      else if (diff > this.threshold) this.prev();
      else this.goTo(this.index);
      this.restart();
    }

    goTo(i, animate = true) {
      const n = this.slides.length;
      this.index = ((i % n) + n) % n;
      if (!animate) this.track.style.transition = 'none';

      if (this.isHints) {
        const target = this.slides[this.index];
        const cs = getComputedStyle(this.track);
        const padding = parseFloat(cs.paddingInlineStart || cs.paddingLeft) || 0;
        this.baseOffset = target.offsetLeft - padding;
        this.track.style.transform = `translateX(-${this.baseOffset}px)`;
      } else {
        this.track.style.transform = `translateX(${-this.index * 100}%)`;
      }

      if (!animate) { void this.track.offsetHeight; this.track.style.transition = ''; }

      this.pagItems.forEach((it, di) => {
        const active = di === this.index;
        it.classList.toggle('is-active', active);
        if (active) it.setAttribute('aria-selected', 'true');
        else it.removeAttribute('aria-selected');
      });

      this.adaptHeight();
      this.applyA11y();
      this.playActiveVideo();
      this.trackView(this.index);
      this.resetTimelineProgress();
      if (this.autoplay && !this.reduceMotion && !this.paused) this.startTimelineProgress();
    }
    next() { this.goTo(this.index + 1); }
    prev() { this.goTo(this.index - 1); }

    hasMaxHeightActive() {
      const isMobile = this.mqMobile.matches;
      return isMobile ? this.maxHeightM > 0 : this.maxHeightD > 0;
    }

    adaptHeight() {
      // Quando max-height está ativo no breakpoint atual, deixa o CSS controlar
      // (aspect-ratio + max-height + object-fit cover). Limpa qualquer style.height inline.
      if (this.hasMaxHeightActive()) {
        this.viewport.style.removeProperty('height');
        return;
      }
      const active = this.slides[this.index];
      if (!active) return;
      const h = active.offsetHeight;
      if (h > 0) this.viewport.style.height = h + 'px';
    }

    bindHeightWatchers() {
      const sig = { signal: this.ac.signal };
      this.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', () => this.adaptHeight(), sig);
      });
      this.querySelectorAll('video').forEach((v) => {
        v.addEventListener('loadedmetadata', () => this.adaptHeight(), sig);
      });
      window.addEventListener('resize', () => {
        if (this.resizeRaf) cancelAnimationFrame(this.resizeRaf);
        this.resizeRaf = requestAnimationFrame(() => {
          this.adaptHeight();
          if (this.isHints) this.goTo(this.index, false);
        });
      }, sig);
    }

    applyA11y() {
      this.slides.forEach((s, si) => {
        const inactive = si !== this.index;
        s.setAttribute('aria-hidden', inactive ? 'true' : 'false');
        s.querySelectorAll('a, button, video, input, select, textarea').forEach((f) => { f.tabIndex = inactive ? -1 : 0; });
      });
    }

    playActiveVideo() {
      this.slides.forEach((s, si) => {
        s.querySelectorAll('video').forEach((v) => {
          const visible = v.offsetParent !== null;
          if (si === this.index && visible) {
            const p = v.play();
            if (p && p.catch) p.catch(() => {});
          } else {
            v.pause();
          }
        });
      });
    }

    bindAutoplayGuards() {
      if (!this.autoplay || this.reduceMotion) return;
      const sig = { signal: this.ac.signal };
      this.addEventListener('mouseenter', () => { this.paused = true; this.stop(); }, sig);
      this.addEventListener('mouseleave', () => { this.paused = false; this.start(); }, sig);
      this.addEventListener('focusin', () => { this.paused = true; this.stop(); }, sig);
      this.addEventListener('focusout', () => { this.paused = false; this.start(); }, sig);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
        else if (!this.paused) this.start();
      }, sig);
    }

    bindEditorEvents() {
      if (!window.Shopify || !window.Shopify.designMode) return;
      const sig = { signal: this.ac.signal };
      document.addEventListener('shopify:block:select', (e) => {
        if (!this.contains(e.target)) return;
        const slide = e.target.closest('[data-lcw-slide-plus]');
        if (!slide) return;
        const i = this.slides.indexOf(slide);
        if (i >= 0) { this.stop(); this.goTo(i); }
      }, sig);
      document.addEventListener('shopify:block:deselect', (e) => {
        if (!this.contains(e.target)) return;
        this.restart();
      }, sig);
    }

    resetTimelineProgress() {
      if (this.progressAnim) {
        this.progressAnim.cancel();
        this.progressAnim = null;
      }
      this.pagItems.forEach((it) => {
        const bar = it.querySelector('.lcw-hero-plus__timeline-progress');
        if (bar) bar.style.width = '';
      });
    }

    startTimelineProgress() {
      if (this.pagStyle !== 'timeline') return;
      if (!this.autoplay || this.reduceMotion) return;
      const activeItem = this.pagItems[this.index];
      if (!activeItem) return;
      const bar = activeItem.querySelector('.lcw-hero-plus__timeline-progress');
      if (!bar || typeof bar.animate !== 'function') return;
      this.progressAnim = bar.animate(
        [{ width: '0%' }, { width: '100%' }],
        { duration: this.speed, fill: 'forwards', easing: 'linear' }
      );
    }

    bindTracking() {
      if (!this.gaEnabled) return;
      if (window.Shopify && window.Shopify.designMode) return;
      const sig = { signal: this.ac.signal };

      this.slides.forEach((s, i) => {
        const mediaLink = s.querySelector('a.lcw-hero-plus__media-link');
        if (mediaLink) {
          mediaLink.addEventListener('click', () => {
            if (this.moved) return;
            this.trackPromotion('select_promotion', s, i);
          }, sig);
        }
        s.querySelectorAll('.lcw-hero-plus__content-inner a, .lcw-hero-plus__content-inner button').forEach((el) => {
          el.addEventListener('click', () => {
            if (this.moved) return;
            this.trackPromotion('select_promotion', s, i);
          }, sig);
        });
      });

      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            this.inView = e.isIntersecting;
            if (e.isIntersecting) this.trackView(this.index);
          });
        }, { threshold: 0.5 });
        this.io.observe(this);
      } else {
        this.inView = true;
        this.trackView(this.index);
      }
    }

    trackView(i) {
      if (!this.gaEnabled || !this.inView) return;
      if (this.viewed.has(i)) return;
      this.viewed.add(i);
      this.trackPromotion('view_promotion', this.slides[i], i);
    }

    trackPromotion(eventName, slide, i) {
      if (!this.gaEnabled || !slide) return;
      const name = slide.dataset.promoName || slide.dataset.promoCreative || ('Slide ' + (i + 1));
      const creative = slide.dataset.promoCreative || '';
      const slot = this.gaLocation + '_' + (i + 1);
      const id = (slide.dataset.promoName || slot)
        .toString().trim().toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '') || slot;

      const item = { promotion_id: id, promotion_name: name, creative_slot: slot, location_id: this.gaLocation };
      if (creative) item.creative_name = creative;
      const payload = { promotion_id: id, promotion_name: name, creative_slot: slot, location_id: this.gaLocation, items: [item] };

      if (this.gaMethod === 'pixel') {
        try {
          if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
            Shopify.analytics.publish('lcw_' + eventName, payload);
          }
        } catch (e) {}
      }
      if (this.gaMethod === 'gtm' && Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({ event: eventName, ecommerce: { items: [item] } });
      }
      if (this.gaMethod === 'gtag' && typeof window.gtag === 'function') {
        window.gtag('event', eventName, payload);
      }
    }

    start() {
      this.stop();
      if (this.single || this.reduceMotion || !this.autoplay) return;
      this.timer = setInterval(() => this.next(), this.speed);
      this.resetTimelineProgress();
      this.startTimelineProgress();
    }
    stop() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
      if (this.progressAnim) { try { this.progressAnim.pause(); } catch (e) {} }
    }
    restart() { if (!this.paused) this.start(); }

    disconnectedCallback() {
      this.stop();
      if (this.io) this.io.disconnect();
      if (this.ac) this.ac.abort();
    }
  }

  if (!customElements.get('lcw-hero-plus-slideshow')) {
    customElements.define('lcw-hero-plus-slideshow', LcwHeroPlusSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
